import { isPlatformServer } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-core-values',
  templateUrl: './core-values.component.html',
  styleUrls: ['./core-values.component.css']
})
export class CoreValuesComponent implements OnInit {

  clickValueItem(event){
    if(event.target.closest(".value-item")){
      let coreValueItemsContainer = event.target.closest(".core-values-items");
      let valueItem = event.target.closest(".value-item");

      let visibleItem = coreValueItemsContainer.querySelector(".visible-value-text");

      if(visibleItem && valueItem!==visibleItem){
        visibleItem.classList.remove("visible-value-text");      
      }  

        valueItem.classList.toggle("visible-value-text");

    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
